import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

const LoadingSpinner = ({
  size = "md",
  className = "",
  color = "primary",
  text = null,
  centered = false,
}) => {
  const sizeClasses = {
    xs: "text-xs",
    sm: "text-sm",
    md: "text-base",
    lg: "text-xl",
    xl: "text-2xl",
  };

  const colorClasses = {
    primary: "text-primary-500",
    white: "text-white",
    slate: "text-slate-500",
    emerald: "text-emerald-500",
  };

  const containerClasses = clsx(
    "flex items-center",
    {
      "justify-center": centered,
      "flex-col space-y-2": text,
      "space-x-2": text && !centered,
    },
    className
  );

  const iconClasses = clsx(
    "animate-spin",
    sizeClasses[size],
    colorClasses[color]
  );

  return (
    <div className={containerClasses}>
      <FontAwesomeIcon icon="spinner" className={iconClasses} />
      {text && (
        <span className={clsx("text-sm", colorClasses[color])}>{text}</span>
      )}
    </div>
  );
};

export default LoadingSpinner;
